// @ts-strict-ignore
import styled from "styled-components";
import Checkmark from "./images/checkbox.svg";
import CheckmarkDisabled from "./images/checkbox_disabled_on.svg";
import ErrorBang from "./images/red_error_bang.svg";
import theme from "themes/light";

export const CheckboxLabel = styled("label")<{
  error?: boolean;
  disabled?: boolean;
  isChecked?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: flex-start;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  &:before {
    content: "";
    background-image: ${({ error }) => (error ? `url(${ErrorBang})` : "none")};
    background-size: 18px 18px;
    display: inline-block;
    width: 18px;
    height: 18px;
    position: absolute;
    left: -29px;
    top: 2px;
  }

  [type="checkbox"] + span {
    display: flex;
    align-items: flex-start;
  }

  [type="checkbox"] + span:before {
    content: "";
    color: transparent;
    background: ${theme.backgroundColors.primary};
    background-size: 18px 18px;
    border: 2px solid
      ${({ error, disabled }) =>
        error
          ? theme.borderColors.negative
          : disabled
            ? theme.borderColors.secondary
            : theme.colorPalette.black};
    border-radius: 2px;
    display: inline-block;
    text-align: center;
    margin-right: 9px;
    margin-left: -27px;
    margin-top: 2px;
    transition:
      200ms ease-in-out background-color,
      300ms ease-in-out border,
      300ms ease-in-out background-image;
    line-height: 13px;
    padding: 2px;
    height: 18px;
    width: 18px;
    box-sizing: border-box;
    min-width: 18px;
  }

  [type="checkbox"]:focus + span:before {
    box-shadow:
      0 0 0 1px white,
      0 0 0 2px ${theme.colorPalette.black};
  }

  [type="checkbox"]:checked + span:before {
    background-image: ${({ disabled, isChecked }) =>
      isChecked && disabled
        ? `url(${CheckmarkDisabled})`
        : `url(${Checkmark})`};
    background-size: 18px 18px;
    background-position: center;
    color: ${theme.colorPalette.white};
    background-color: ${theme.colorPalette.black};
  }
  [type="checkbox"]:focus + span:before {
    border-color: ${theme.colorPalette.black};
  }
`;

export const StyledLabel = styled("span")<{ error?: boolean }>`
  color: ${({ error }) =>
    error ? theme.textColors.negative : theme.textColors.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
`;
